<div id="rootDiv">
  @if (tabs.length) {
    <patron-tabview [tabs]="tabs" [activeIndex]="activeTabIndex" (tabChanged)="tabChanged($event)">
    </patron-tabview>
  }

  <ng-template #principalTemplate>
    <div>
      <ts-body-header
        [unconfirmedTicket]="entity"
        [loadingLogs]="loadingTicketLogs"
        [openedLogs]="openedLogs"></ts-body-header>
      @if (showTabsBodies) {
        <ts-main-tab
          [unconfirmedTicket]="entity"
          [defaultPageSize]="defaultPageSize"
          [userResp]="userResp"
          [userDes]="userDes"
          [users]="users"
          [usersInput]="usersInput"
          [loadingUsers]="loadingUsers"
          [user]="user"
          (updateUserResp)="userResp = $event"
          (updateUserDes)="userDes = $event"
          [attachments]="attachments"
          [taskId]="taskId"
          (saved)="saved.emit($event)"
          (saving)="saving.emit($event)"
          (save)="save()"></ts-main-tab>
      }
    </div>
  </ng-template>
  <ng-template #informacoesTemplate>
    <div class="mb-3">
      <ts-body-header
        [unconfirmedTicket]="entity"
        [loadingLogs]="loadingTicketLogs"
        [openedLogs]="openedLogs"></ts-body-header>
      @if (showTabsBodies) {
        <ts-info-tab
          [isSaving]="isSaving"
          [user]="user"
          (save)="save()"
          [unconfirmedTicket]="entity"
          [ticketLogs]="ticketLogs"
          (saving)="saving.emit($event)"></ts-info-tab>
      }
    </div>
  </ng-template>

  @if (isSprintCanRead()) {
    <ng-template #tarefasTemplate>
      <div>
        <ts-body-header
          [unconfirmedTicket]="entity"
          [loadingLogs]="loadingTicketLogs"
          [openedLogs]="openedLogs"></ts-body-header>
        @if (showTabsBodies) {
          <app-tasks
            [entity]="entity"
            [userDes]="userDes!"
            [users]="users!"
            [usersInput]="usersInput"
            [loadingUsers]="loadingUsers"
            [openedLogs]="openedLogs"
            [highlightTaskId]="taskId"
            [saving]="isSaving!"
            [users]="users!"
            (save)="save()"
            (assembleTicket)="assembleTicket($event)"
            (ticketLogs)="openTicketLogsModal($event)"
            (saved)="saved.emit($event)">
          </app-tasks>
        }
      </div>
    </ng-template>
  }

  <ng-template #outrosTemplateFields>
    <div>
      <div>
        <ts-body-header
          [unconfirmedTicket]="entity"
          [loadingLogs]="loadingTicketLogs"
          [openedLogs]="openedLogs"></ts-body-header>
      </div>
      @if (showTabsBodies) {
        <ts-others-tab
          [unconfirmedTicket]="entity"
          [userExec]="userExec"
          [usersPart]="usersPart"
          [users]="users"
          [usersInput]="usersInput"
          [loadingUsers]="loadingUsers"
          [wasValidated]="wasValidated"
          [defaultPageSize]="defaultPageSize"
          (updateUserExec)="userExec = $event"
          (updateUsersPart)="usersPart = $event"
          (cleanExpectedDate)="cleanExpectedDate()"></ts-others-tab>
      }
    </div>
  </ng-template>

  <ng-template #devTemplate>
    <div>
      <div>
        <ts-body-header
          [unconfirmedTicket]="entity"
          [loadingLogs]="loadingTicketLogs"
          [openedLogs]="openedLogs"></ts-body-header>
      </div>
      @if (showTabsBodies) {
        <ts-dev-tab [unconfirmedTicket]="entity" [user]="user"></ts-dev-tab>
      }
    </div>
  </ng-template>

  <ng-template #documentationsTemplate>
    <div>
      @if (showTabsBodies && entity) {
        <ts-documentations-tab
          [entity]="entity"
          [canWrite]="isDocumentationCanWrite()"></ts-documentations-tab>
      }
    </div>
  </ng-template>

  <!--A aba de apontamentos não vai ter, vai ser pelo modal-->
  <!-- <tab (selectTab)="changeTab($event)" [id]="tabIds[0]">
  <ng-template tabHeading>
    <i class="fa fa-home"></i>
    <span class="d-none d-md-inline ml-1">Principal</span>
  </ng-template>

  <div>
    <ts-body-header
      [unconfirmedTicket]="unconfirmedTicket"
      [openedLogs]="openedLogs"
    ></ts-body-header>
    <ts-main-tab
      [unconfirmedTicket]="unconfirmedTicket"
      [ticketStatuses]="ticketStatuses"
      [defaultPageSize]="defaultPageSize"
      [userResp]="userResp"
      [userDes]="userDes"
      [users]="users"
      [usersInput]="usersInput"
      [loadingUsers]="loadingUsers"
      [user]="user"
      (updateUserResp)="userResp = $event"
      (updateUserDes)="userDes = $event"
      [attachments]="attachments"
      [taskId]="taskId"
    ></ts-main-tab>
  </div>
</tab> -->

  <!-- <tab (selectTab)="changeTab($event)" [id]="tabIds[1]">
<ng-template tabHeading>
  <i class="fa fa-info-circle"></i>
  <span class="d-none d-md-inline ml-1">Informações</span>
</ng-template>

<div>
  <div class="mb-3">
    <ts-body-header
      [unconfirmedTicket]="unconfirmedTicket"
      [openedLogs]="openedLogs"
    ></ts-body-header>
  </div>
  <ts-info-tab
    [saving]="isSaving"
    [unconfirmedTicket]="unconfirmedTicket"
    [user]="user"
    [ticketLogs]="ticketLogs"
    (save)="save($event)"
  ></ts-info-tab>
</div>
</tab>

<tab (selectTab)="changeTab($event)" [id]="tabIds[2]">
  <ng-template tabHeading>
    <i class="fa fa-tasks"></i>
    <span class="d-none d-md-inline ml-1">Tarefas</span>
  </ng-template>

  <div>
    <div class="mb-3">
      <ts-body-header
        [unconfirmedTicket]="unconfirmedTicket"
        [openedLogs]="openedLogs"
      ></ts-body-header>
    </div>
    <app-tasks
      [entity]="unconfirmedTicket"
      [expectedDateString]="expectedDateString"
      [userDes]="userDes"
      [ticketStatuses]="ticketStatuses"
      (saveTicket)="saveTicket($event)"
      [users]="users"
      [usersInput]="usersInput"
      [loadingUsers]="loadingUsers"
      (expectedDateStringChanged)="expectedDateStringChanged($event)"
      [saving]="isSaving"
      (ticketLogs)="openTicketLogsModal($event)"
      [openedLogs]="openedLogs"
      [highlightTaskId]="taskId"
      >
    </app-tasks>
  </div>
</tab>

<tab (selectTab)="changeTab($event)" [id]="tabIds[3]">
  <ng-template tabHeading>
    <i class="fa fa-edit"></i>
    <span class="d-none d-md-inline ml-1">Outros</span>
  </ng-template>

  <div>
    <div class="mb-3">
      <ts-body-header
        [unconfirmedTicket]="unconfirmedTicket"
        [openedLogs]="openedLogs"
      ></ts-body-header>
    </div>
    <ts-others-tab
      [unconfirmedTicket]="unconfirmedTicket"
      [expectedDateString]="expectedDateString"
      (expectedDateStringChanged)="expectedDateStringChanged($event)"
      (cleanExpectedDate)="cleanExpectedDate()"
      [userExec]="userExec"
      [usersPart]="usersPart"
      [users]="users"
      [usersInput]="usersInput"
      [loadingUsers]="loadingUsers"
      [wasValidated]="wasValidated"
      [defaultPageSize]="defaultPageSize"
      (updateUserExec)="userExec = $event"
      (updateUsersPart)="usersPart = $event"
    ></ts-others-tab>
  </div>
</tab> -->

  <!-- <tab (selectTab)="changeTab($event)" [id]="tabIds[4]" class="p-0">
<ng-template tabHeading>
  <i class="fa fa-code"></i>
  <span class="d-none d-md-inline ml-1">Desenvolvimento</span>
</ng-template>

<div>
  <div class="pt-3 px-3 pb-0 bg-primary">
    <ts-body-header
      [unconfirmedTicket]="unconfirmedTicket"
      [openedLogs]="openedLogs"
    ></ts-body-header>
  </div>
  <ts-dev-tab
    [unconfirmedTicket]="unconfirmedTicket"
    [user]="user"
  ></ts-dev-tab>
</div>
</tab> -->

  <!-- </tabset> -->

  @if (showSaveButton && (activeTabIndex === 0 || activeTabIndex === 3)) {
    <div class="p-3 pt-0 row mx-0 justify-content-end">
      <div class="col-auto pr-0">
        <ts-save-button [isSaving]="isSaving" (save)="save()"></ts-save-button>
      </div>
    </div>
  }

  @if (showSaveButton) {
    <div class="h-100">
      <!--Oi eu estou aqui só pra ocupar o restante da altura com uma cor branca-->
    </div>
  }
</div>

<patron-modal
  title="Limpar data de previsão"
  [visible]="confirmExpectedDateCleanVisible"
  confirmButtonText="Sim"
  cancelButtonText="Cancelar"
  (confirm)="confirmExpectedDateClean()"
  [confirmButtonLoading]="isSaving === true">
  <p>Tem certeza de que deseja limpar a data de previsão do ticket?</p>
</patron-modal>

<app-ticket-logs-modal
  [visible]="logsModalData.visible"
  [entity]="logsModalData.entity"
  [user]="logsModalData.user"
  [taskId]="logsModalData.taskId"
  [inputTask]="logsModalData.inputTask"
  [inputSystem]="logsModalData.inputSystem"
  (assembleTicket)="assembleTicket(logsModalData.entity)"
  (closed)="logsModalClosed()"
  (saved)="saved.emit($event)"></app-ticket-logs-modal>

<patron-modal
  [visible]="unsavedDataWarningModalVisible"
  title="Dados Não salvos"
  confirmButtonText="ok"
  (confirm)="acceptEditTicket()"
  size="sm"
  id="modalPending"
  [backdrop]="'static'"
  #modalPending
  [closeButton]="false">
  <div>Existem dados não salvos!</div>
</patron-modal>

@if (loading || assemblingTicket) {
  <patron-spinner size="lg" [centered]="true"></patron-spinner>
}
